// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    envName: 'dev',
    hostname: 'tourtoyota.dev.toyota.com',
    production: false,
    redirectUrl: `https://login.microsoftonline.com/tmnatest.onmicrosoft.com/oauth2/authorize?client_id=1b32b72d-2208-48b7-9c1b-5dd881c7aabd&response_type=id_token&redirect_uri=https%3A%2F%2FTourToyota.dev.toyota.com%2F%23%2Flogin%2F&scope=openid&state=12345&nonce=678910`,
    adminBaseUrl : 'https://x9ph2zk8o6.execute-api.us-east-1.amazonaws.com/dev/api/',
    createReservationBaseUrl : 'https://waufu8ydx3.execute-api.us-east-1.amazonaws.com/dev/api/',
    reportBaseUrl:'https://svvk1ii2l5.execute-api.us-east-1.amazonaws.com/dev/api/',
    regisBaseUrl: 'https://roqvb12lvd.execute-api.us-east-1.amazonaws.com/dev/api/',
    cancelEmailBaseUrl:'https://59bvhpe396.execute-api.us-east-1.amazonaws.com/dev/api/',
    managePlantBaseUrl:'https://saxbxmvb1k.execute-api.us-east-1.amazonaws.com/dev/api/',
    saveTokenBaseUrl:'https://jld772e20j.execute-api.us-east-1.amazonaws.com/dev/api/',
    tourSaveTokenUrl:'https://jld772e20j.execute-api.us-east-1.amazonaws.com/dev/api/JWT',
    exportDownloadUrl: 'https://d3j2rxbv4mtei3.cloudfront.net/'

  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
  